export const PEGMAN_SAFE_OFFSET_PX = 68;
export const CHAT_BUTTON_SAFE_OFFSET_PX = 60;
export const MAPS_ATTRIBUTION_BAR_BOTTOM_OFFSET_PX = 20;
export const RIGHT_SIDE_RIGHT_OFFSET_PX = 5;
